import { Outlet } from "@opendash/router";
import * as React from "react";
import { Boundary, OpenDashGlobals } from "..";
import Layout from "./_layout";
export const RouterRootHandler = React.memo(function RouterRootHandler() {
    return (React.createElement(React.Fragment, null,
        React.createElement(OpenDashGlobals, null),
        React.createElement(Boundary, null,
            React.createElement(Layout, null,
                React.createElement(Boundary, null,
                    React.createElement(Outlet, null))))));
});
//# sourceMappingURL=RouterRootHandler.js.map